import { render, staticRenderFns } from "./YtbPlayer.vue?vue&type=template&id=1cc180a6&scoped=true&"
import script from "./YtbPlayer.vue?vue&type=script&lang=js&"
export * from "./YtbPlayer.vue?vue&type=script&lang=js&"
import style0 from "./YtbPlayer.vue?vue&type=style&index=0&id=1cc180a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc180a6",
  null
  
)

export default component.exports